import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen md:min-h-[90vh] flex items-center pt-20 md:pt-0 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-slate-900 relative">
          <img 
            src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=2832&auto=format&fit=crop" 
            alt="Background" 
            className="w-full h-full object-cover opacity-40" 
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/70 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl animate-fade-in-up">
          {/* Badge */}
          <div className="inline-block mb-6 px-4 py-2 bg-secondary/80 backdrop-blur-sm text-secondary-foreground rounded-full text-sm font-medium border border-secondary">
            Oportunidades de Inversión
          </div>

          {/* Heading */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-balance text-foreground mb-6 leading-[0.9] tracking-tight">
            INVERTÍ<br />EN TU FUTURO
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-xl text-balance font-light leading-relaxed">
            Descubrí propiedades y terrenos exclusivos en ubicaciones estratégicas. Tu próxima gran inversión empieza acá.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={() => scrollToSection('propiedades')}
              className="px-8 py-4 bg-primary text-primary-foreground rounded-full font-medium hover:bg-primary/90 transition-all flex items-center justify-center gap-2 group shadow-xl shadow-primary/20"
            >
              Explorar Propiedades
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="px-8 py-4 bg-white border border-gray-200 text-foreground rounded-full font-medium hover:bg-gray-50 transition-colors shadow-sm"
            >
              Agendar Consulta
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce opacity-60">
          <span className="text-xs font-medium tracking-widest uppercase text-muted-foreground">
            Desplaza para explorar
          </span>
          <ArrowDown className="w-5 h-5 text-muted-foreground" />
        </div>
      </div>
    </section>
  );
};

export default Hero;